import { render, staticRenderFns } from "./EmergencyMessageAlert.vue?vue&type=template&id=381d2e2d&scoped=true"
import script from "./EmergencyMessageAlert.vue?vue&type=script&lang=js"
export * from "./EmergencyMessageAlert.vue?vue&type=script&lang=js"
import style0 from "./EmergencyMessageAlert.vue?vue&type=style&index=0&id=381d2e2d&prod&lang=less&scoped=true"
import style1 from "./EmergencyMessageAlert.vue?vue&type=style&index=1&id=381d2e2d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381d2e2d",
  null
  
)

export default component.exports